import { render, staticRenderFns } from "./NewEarnings.vue?vue&type=template&id=0dc2d50e"
import script from "./NewEarnings.vue?vue&type=script&lang=js"
export * from "./NewEarnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports